import { useMutation } from '@tanstack/react-query';

import {
  API_ENDPOINT_KEYS,
  MUTATION_KEY,
  SERVICE_AUTH_ENDPOINTS,
} from '~common';
import { postAuthRequest } from '~services';

export interface ResetPasswordRequest {
  password: string;
  token?: string;
}

export const useResetPasswordMutation = () => {
  const mutationFn = (reqBody: ResetPasswordRequest) => {
    return postAuthRequest({
      path: SERVICE_AUTH_ENDPOINTS[API_ENDPOINT_KEYS.RESET_PASSWORD],
      data: reqBody,
      ignoreAuthHeader: true,
    });
  };

  return useMutation({
    mutationKey: [MUTATION_KEY.RESET_PASSWORD],
    mutationFn,
  });
};
